import { Button, ButtonProps } from "@mui/material";
import { FunctionComponent } from "react";

interface IStyledButtonProps {
  spacing?: number;
  ml?: string;
}

export const StyledButton: FunctionComponent<
  ButtonProps & IStyledButtonProps
> = ({ children, ml, spacing = 2, ...rest }) => {
  return (
    <Button
      sx={{
        width: "max-content !important",
        minWidth: "100px !important",
        padding: "6px 16px !important",
        borderRadius: "4px !important",
        marginLeft: ml ? ml : "8px !important",
        backgroundColor: "var(--kyocera-blue)",
        textTransform: "none",
        color: "var(--kyocera-white)",
        "& span.MuiButton-label": {
          textTransform: "none",
          whiteSpace: "nowrap",
        },
        "&:hover": {
          backgroundColor: "var(--kyocera-blue) !important", // Added !important
          color: "var(--kyocera-white) !important", // Added !important
          boxShadow: [
            "0px 2px 2px 0px rgba(0,0,0,0.14)",
            "0px 1px 5px 0px rgba(0,0,0,0.12)",
          ].join(","),
        },
        "&.Mui-disabled": {
          opacity: 0.5,
          backgroundColor: "var(--kyocera-bg-grey) !important",
          color: "var(--kyocera-text-grey) !important",
          boxShadow:
            "0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12)",
        },
        "&.MuiButton-containedLight": {
          backgroundColor: "var(--kyocera-cp-background-grey)",
          color: "var(--kyocera-dark-grey)",
        },
        "&.MuiButton-contained": {
          backgroundColor: "var(--kyocera-text-grey)",
          color: "var(--kyocera-white)",
        },
        "&.MuiButton-containedPrimary": {
          backgroundColor: "var(--kyocera-blue)",
          color: "var(--kyocera-white)",
        },
        "&.MuiButton-containedSecondary": {
          backgroundColor: "var(--kyocera-text-grey)",
          color: "var(--kyocera-white)",
        },
        "&.MuiButton-containedActionWhite": {
          backgroundColor: "var(--kyocera-white)",
          color: "var(--kyocera-text-grey)",
        },
        "&.MuiButton-ActionPrimary": {
          backgroundColor: "var(--kyocera-blue)",
          color: "var(--kyocera-white)",
          "&.Mui-disabled": {
            backgroundColor: "var(--kyocera-white)", // Directly apply the styles
            color: "var(--kyocera-text-grey)", // Directly apply the styles
          },
        },
        "&.MuiButton-containedError": {
          backgroundColor: "var(--important-red)",
          color: "var(--kyocera-white)",
        },
        "&.non-tranform": {
          textTransform: "none",
        },
      }}
      {...rest}
    >
      {children}
    </Button>
  );
};
